<template>
  <div id="my_maintenance">
    <div style="position: sticky; top: 0">
      <van-tabs
        v-model="active"
        lazy-render
        title-active-color="#F00724"
        title-inactive-color="#999999"
        @change="onChange(active)"
        animated
      >
        <van-tab v-for="(tab, index) in tabList" :key="index" :name="tab.name">
          <!-- 自定义图标-->
          <template #title>
            {{ tab.title }}
            <div id="tab_title">
              <van-badge
                :content="tab.count"
                max="99"
                v-if="tab.count > 0"
              /></div
          ></template>
        </van-tab>
      </van-tabs>
    </div>
    <div v-if="activeType == 0">
      <div class="main_user_infor">
        <div class="main_user_box">
          <!-- 我的信息 -->
          <div class="main_user_infor_box">
            <div>
              <div class="main_user_my_infor">我的信息</div>
              <div class="main_user_my_code">
                <span @click="onClickSuperiorCard"> 查看我的二维码 </span>
              </div>
            </div>
            <div class="main_sculpture">
              <img
                v-if="
                  userInforList.avatarUrl != null &&
                  userInforList.avatarUrl !== undefined &&
                  userInforList.avatarUrl !== ''
                "
                mode="aspectFill"
                class="avatar"
                :src="userInforList.avatarUrl"
              />
              <img
                class="avatar"
                v-else
                src="../../../assets/images/default.jpeg"
                alt=""
              />
              <div class="infor">
                <div class="flex betweenBottom">
                  <svg class="iconSize" aria-hidden="true">
                    <use xlink:href="#icon-weixinnichengtubiao"></use>
                  </svg>
                  <div class="ellipsis size_color">
                    {{ userInforList.userName }}
                  </div>
                </div>
                <div class="flex">
                  <svg class="iconSize" aria-hidden="true">
                    <use xlink:href="#icon-shoujitubiao"></use>
                  </svg>
                  <div class="size_color">{{ userInforList.phoneNumber }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 服务人信息 -->
          <div class="main_user_infor_box" v-if="serverInfor">
            <div>
              <div class="main_user_my_infor">服务人信息</div>
              <div class="main_user_my_code">
                <span @click="onSuperior"> 查看服务人二维码 </span>
              </div>
            </div>
            <div class="main_sculpture">
              <img
                v-if="
                  serviceInfoList.avatarUrl != null &&
                  serviceInfoList.avatarUrl !== undefined &&
                  serviceInfoList.avatarUrl !== ''
                "
                mode="aspectFill"
                class="avatar"
                :src="serviceInfoList.avatarUrl"
              />

              <img
                class="avatar"
                v-else
                src="../../../assets/images/default.jpeg"
                alt=""
              />
              <div class="infor">
                <div class="flex betweenBottom">
                  <svg class="iconSize" aria-hidden="true">
                    <use xlink:href="#icon-weixinnichengtubiao"></use>
                  </svg>
                  <div class="ellipsis size_color">
                    {{ serviceInfoList.userName }}
                  </div>
                </div>
                <div class="flex">
                  <svg class="iconSize" aria-hidden="true">
                    <use xlink:href="#icon-shoujitubiao"></use>
                  </svg>
                  <div class="size_color">
                    {{ serviceInfoList.phoneNumber }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="my_hire_now" @click="changeServer()">更换服务人</div>
          <!-- <div class="my_hire_now_disable"
               v-if="!serverSubmit">更换服务人</div> -->
        </div>

        <!-- <div class="tip"
             v-if="serverTip">* 您已提交更换服务人申请，请到【申请记录】中查看</div> -->
      </div>
    </div>
    <div v-if="activeType == 1 || activeType == 2">
      <div v-if="aplicationList.length != 0" class="my_hire_concent_box">
        <!-- 分页 -->
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了~"
          @load="onLoad"
        >
          <div v-if="activeType == 1">
            <div
              class="aplication_list"
              v-for="(item, index) in aplicationList"
              :key="index"
            >
              <div class="aplication_list_box">
                <div class="aplication_list_top">
                  <div class="aplication_list_top_left">
                    <div class="name top ellipsis">
                      申请人昵称：{{ item.applyNickName }}
                    </div>
                    <div class="name">申请人手机：{{ item.phoneNumber }}</div>
                    <div class="name">申请时间：{{ item.applyTime }}</div>
                  </div>
                  <div class="aplication_list_top_right">
                    <span class="wait" v-if="item.mainTenanceStatus == 0"
                      >待回复</span
                    >
                    <span class="reject" v-if="item.mainTenanceStatus == 1"
                      >已驳回</span
                    >
                    <span class="pass" v-if="item.mainTenanceStatus == 2"
                      >已通过</span
                    >
                  </div>
                </div>
                <div class="aplication_list_bottom">{{ item.source }}</div>
              </div>
            </div>
          </div>
          <!-- 雇佣记录 -->
          <div v-if="activeType == 2">
            <div
              class="aplication_list"
              v-for="(item, index) in aplicationList"
              :key="index"
            >
              <div class="aplication_list_box">
                <div class="aplication_list_top">
                  <div class="aplication_list_top_left">
                    <div class="name top ellipsis">
                      申请人昵称：{{ item.applyNickName }}
                    </div>
                    <div class="name">申请人手机：{{ item.phoneNumber }}</div>
                    <div class="name">申请时间：{{ item.applyTime }}</div>
                  </div>
                  <div class="aplication_list_top_right">
                    <div
                      class="reject_btn"
                      v-if="item.mainTenanceStatus == 0"
                      @click="rejectAplication(item.userId)"
                    >
                      驳回
                    </div>
                    <span class="reject" v-if="item.mainTenanceStatus == 1"
                      >已驳回</span
                    >
                    <span class="reject" v-if="item.mainTenanceStatus == 2"
                      >已超时</span
                    >
                  </div>
                </div>
                <div class="aplication_list_bottom">{{ item.source }}</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <!-- loading -->

    <!-- <div class="wrapper"> -->
    <loading v-if="isLoading"></loading>
    <!-- </div> -->

    <!-- 空页面 -->
    <div
      class="noShares"
      v-if="aplicationList.length == 0 && (activeType == 1 || activeType == 2)"
    >
      <div class="nullPage">
        <img src="../../../assets/images/update.png" alt />
      </div>
      <div class="noShareText">{{ emptyTip }}</div>
    </div>
    <!--上传二维码名片  -->
    <div class="businessCard" style="position: relative">
      <van-popup v-model="IsShowSuperiorCard" class="popupBorder">
        <MyBusinessCard v-if="IsShowSuperiorCard"></MyBusinessCard>
        <van-icon
          name="cross"
          @click="onClose"
          color="#999"
          size="18px"
          style="position: absolute; z-index: 10; top: 16px; right: 16px"
        />
      </van-popup>
    </div>
    <!-- 我的服务人弹窗 -->
    <div class="businessCard" style="position: relative">
      <van-popup v-model="IsSuperior" class="popupBorder">
        <superior v-if="IsSuperior" :msgSuperior="msgSuperior"></superior>
        <van-icon
          name="cross"
          @click="onSuperiorClose"
          color="#999"
          size="18px"
          style="position: absolute; z-index: 10; top: 16px; right: 16px"
        />
      </van-popup>
    </div>
    <!-- 更换服务人弹窗 -->
    <van-dialog
      v-model="showDialog"
      v-if="showDialog"
      :before-close="onBeforeClose"
      show-cancel-button
      title="更换服务人"
      confirmButtonText="确定"
    >
      <div class="main_submit">
        <!-- <div class="main_tip">
          提交申请后，服务人将收到通知。如果服务人在2天内没有回复，系统会自动更换服务人。
        </div> -->
        <div class="main_tip">是否确认更换服务人？</div>
        <!-- <van-field v-model="message"
                   rows="3"
                   autosize
                   type="textarea"
                   maxlength="50"
                   placeholder="请输入更换原因（50字以内）"
                   show-word-limit />
        <div v-if="soureceMessage"
             class="sourece_message">请输入更换原因</div> -->
      </div>
    </van-dialog>
    <!-- 提交成功 -->
    <!-- 弹窗 -->
    <van-dialog v-model="submitSuccess" confirmButtonText="我知道了">
      <div class="loan_dig">
        <van-icon name="passed" size="49" color="rgba(25, 193, 92, 1)" />
        <div class="loan_tip">更换服务人成功</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  Toast,
  Dialog,
  List,
  Loading,
  Overlay,
  Popup,
  Icon,
  Picker,
  Field,
  Badge,
} from "vant";
import loading from "../../components/loading/loading";
import { mapGetters } from "vuex";
import MyBusinessCard from "../../components/MyBusinessCard/index";
import hireService from "../../api/hire/index";
import serviceSuperior from "../../api/superior/index";
import superior from "../../components/superior/index";
import serviceMaintenance from "../../api/maintenance/index";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [List.name]: List,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    [Field.name]: Field,
    [Badge.name]: Badge,
    loading,
    MyBusinessCard,
    superior,
  },
  props: {},
  data() {
    return {
      // tablist
      tabList: [
        { name: "0", title: "会员信息", count: "0" },
        { name: "1", title: "申请记录", count: "0" },
        { name: "2", title: "客情维护", count: "0" },
      ],
      active: 0,
      activeType: 0,
      isChooseDate: "",
      showmonthData: false,
      monthData: [],
      isLoading: false,
      page: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      aplicationList: [],
      IsShowSuperiorCard: false, //是否显示二维码名片
      msgSuperior: "", //服务人传值
      showDialog: false, //更换服务人弹窗
      message: "",
      submitSuccess: false,
      userInforList: [], //用户信息
      serviceInfoList: [], //服务人信息
      // 是否显示的各种状态
      serverSubmitAll: false,
      serverSubmit: false, //服务人按钮
      serverTip: false, //提示
      serverInfor: true, //服务人信息
      emptyTip: "",
      soureceMessage: false,
      IsSuperior: false, //是否显示我的上级
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 关闭二维码名片
    onClose() {
      this.IsShowSuperiorCard = false;
    },
    // 关闭我的服务人
    onSuperiorClose() {
      this.IsSuperior = false;
    },
    // 驳回 rejectMaintenance
    rejectAplication(userId) {
      let data = {
        userId: userId,
      };
      this.isLoading = true;
      serviceMaintenance
        .rejectMaintenance(data)
        .then((res) => {
          if (res.statusCode == 200) {
            this.page = 1;
            this.pageSize = 20;
            this.aplicationList = [];
            this.getMaintenanceCount();
            this.getKqwhList();
            this.isLoading = false;
          } else {
            this.isLoading = false;
            Toast(errors);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          // Toast(err);
        });
    },
    // 我的服务人 显示二维码
    onSuperior() {
      this.isLoading = true;
      serviceSuperior.get().then((res) => {
        if (res.statusCode == 200) {
          if (res.data == "您的服务人未上传二维码名片") {
            this.isLoading = false;
            Toast(res.data);
            this.IsSuperior = false;
          } else {
            this.isLoading = false;
            this.IsSuperior = true;
            this.msgSuperior = res.data;
          }
        } else {
          this.isLoading = false;
          this.IsSuperior = false;
          Toast(res.errors);
        }
      });
    },
    // 上传二维码名片
    onClickSuperiorCard() {
      this.IsShowSuperiorCard = true;
    },
    // tab切换
    onChange(active) {
      this.page = 1;
      this.pageSize = 20;
      this.isLoading = true;
      this.finished = false;
      this.loading = false;
      this.activeType = active;
      this.aplicationList = [];
      if (active == 0) {
        this.getUserInfor();
      }
      if (active == 1 || active == 2) {
        this.onLoad();
      }
    },
    // 弹窗提交
    onBeforeClose(action, done) {
      if (action === "confirm") {
        // 点击确定走这里
        // if (this.message.trim() !== '' && this.message.trim() !== undefined && this.message.trim() !== null) {
        this.isLoading = true;
        let data = {
          source: this.message,
        };
        serviceMaintenance
          .applyChangeService(data)
          .then((res) => {
           
            if (res.statusCode == 200) {
              if (res.data.status == false) {
                Toast(res.data.description);
                this.isLoading = false;
                this.showDialog=false
                return;
              }
              done(true);
              this.submitSuccess = true;
              this.getUserInfor();
              this.isLoading = false;
            } else {
              this.isLoading = false;
              Toast(errors);
            }
          })
          .catch((errors) => {
            this.showDialog=false
            this.isLoading = false;
             let Aerr =JSON.parse(errors) 
              console.log(errors,Aerr,'Aerr')
            Toast(Aerr.Description);
          });
        // } else {
        //   this.soureceMessage = true
        //   return done(false) // 阻止弹窗关闭
        // }
      } else {
        // 点击取消走这里
        done(true); // 关闭弹窗, true可以省略
      }
    },
    // 获取客情维护数量
    getMaintenanceCount() {
      // this.isLoading = true
      serviceMaintenance
        .getMaintenanceCount()
        .then((res) => {
          if (res.statusCode == 200) {
            this.tabList[2].count = res.data;
          } else {
            Toast(errors);
          }
        })
        .catch((err) => {
          // Toast(err);
        });
    },
    // 更换服务人员
    changeServer() {
      this.soureceMessage = false;
      this.showDialog = true;
      this.message = "";
    },
    //下拉加载列表
    getlist() {
      this.finished = false;
      this.loading = false;
      this.onLoad();
    },
    onLoad() {
      try {
        if (this.activeType == 1) {
          this.emptyTip = "暂无申请记录";
          serviceMaintenance
            .getApplyRecordList(this.page, this.pageSize)
            .then((res) => {
              if (res.statusCode == 200) {
                const results = res.data.rows;
                this.aplicationList.push(...results);
                this.isLoading = false;
                this.loading = false;
                this.finished = false;
                if (results.length > 0) {
                  // 有，则更新获取下一个数据的页码
                  this.page++;
                } else {
                  // 没有，则将加载状态finished设置为结束
                  this.finished = true;
                }
              } else {
                // this.isLoading = false
                Toast(errors);
              }
            })
            .catch((err) => {
              // this.isLoading = false
              // Toast(err);
            });
        }
        if (this.activeType == 2) {
          this.emptyTip = "暂无维护";
          this.getKqwhList();
        }
      } catch (errors) {
        this.isLoading = false;
        Toast(errors);
      } finally {
        // this.isLoading = false
      }
    },
    // 客情维护列表
    getKqwhList() {
      serviceMaintenance
        .getMaintenanceList(this.page, this.pageSize)
        .then((res) => {
          if (res.statusCode == 200) {
            const result = res.data.rows;
            this.aplicationList.push(...result);
            this.isLoading = false;
            this.loading = false;
            this.finished = false;
            if (result.length > 0) {
              // 有，则更新获取下一个数据的页码
              this.page++;
            } else {
              // 没有，则将加载状态finished设置为结束
              this.finished = true;
            }
          } else {
            this.isLoading = false;
            Toast(errors);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          // Toast(err);
        });
    },
    // 获取会员信息
    getUserInfor() {
      this.isLoading = true;
      serviceMaintenance
        .userMaintenance()
        .then((res) => {
          if (res.statusCode == 200) {
            let data = res.data;
            // debugger
            this.userInforList = data.userInfo;
            if (
              data.serviceInfo != null &&
              data.serviceInfo != "" &&
              data.serviceInfo != undefined
            ) {
              this.serviceInfoList = data.serviceInfo;
            }
            // 他的上级是否是顶点
            // if (data.serviceIsTop == true) {
            //   this.serverSubmitAll = true
            //   // this.serverSubmit = false
            //   this.serverInfor = true
            // } else {
            //   this.serverSubmitAll = true
            //   this.serverSubmit = true
            //   // this.serverTip = true
            //   this.serverInfor = true
            // }
            // // 能否申请
            // if (data.isApply == true) {
            //   this.serverTip = false
            // }
            // // 他的上级是否是顶点并且能否申请
            // if (data.serviceIsTop == false && data.isApply == false) {
            //   this.serverSubmitAll = true
            //   this.serverSubmit = false
            //   // this.serverTip = true
            //   this.serverInfor = true
            // }
            // // 顶点不展示服务人信息 模块
            if (data.isTop == true) {
              this.serverSubmitAll = false
              this.serverTip = false
              this.serverInfor = false
            }

            this.isLoading = false;
          } else {
            this.isLoading = false;
            Toast(errors);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          // Toast(err);
        });
    },
  },
  created() {
    // 获取会员信息
    this.getUserInfor();
    //获取客情维护数量
    this.getMaintenanceCount();
  },
  mounted() {
    // this.onLoad()
  },
  computed: {
    ...mapGetters(["agentShow"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },
};
</script>
<style lang="less" >
#my_maintenance {
  width: 100%;
  min-height: 100vh;
  background: #f8f8f8;
  .sourece_message {
    font-size: 12px;
    color: #f00724;
    text-align: left;
  }
  #tab_title {
    position: absolute;
    top: 3px;
    right: 15px;
  }
  .aplication_list {
    // margin-top: 4px;
    padding-bottom: 8px;
    overflow: hidden;
    .aplication_list_box {
      // padding: 16px;
      margin: 0 12px 0 12px;
      height: auto;
      background: #ffffff;
      box-shadow: 0px 4px 8px 0px #e6e6e6;
      border-radius: 8px;
      .aplication_list_top {
        height: 98px;
        box-sizing: border-box;
        border-bottom: 1px solid #ececec;
        margin: 0 16px 0 16px;
        .aplication_list_top_left {
          float: left;
          .top {
            margin-top: 16px;
            width: 220px;
          }
          .name {
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 14px;
            margin-bottom: 12px;
          }
        }
        .aplication_list_top_right {
          float: right;
          height: 98px;
          line-height: 98px;
          font-weight: 600;
          .reject_btn {
            display: inline-block;
            width: 80px;
            height: 32px;
            background: #f00724;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
            text-align: center;
            line-height: 32px;
          }
          .wait {
            color: #faad14;
          }
          .reject {
            color: #f00724;
          }
          .pass {
            color: #19c15c;
          }
        }
      }
      .aplication_list_bottom {
        height: auto;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        margin-top: 11px;
        padding: 0 16px 16px 16px;
      }
    }
  }
  .aplication_list:first-child {
    margin-top: 12px;
  }
  .loan_dig {
    height: 124px;
    padding-top: 24px;
    text-align: center;
  }
  .loan_tip {
    margin-top: 20px;
    font-size: 14px;
    color: #000000;
  }
  .main_submit {
    margin: 16px 16px 16px 16px;

    .van-cell {
      padding: 12px 12px 12px 120x !important;
      height: 110px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #ececec;
      margin-top: 12px;
      margin-bottom: 3px;
    }
  }
  .main_tip {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    text-align: center;
  }
  .tip {
    display: block;
    margin: 24px auto 0 auto;
    width: 100%;
    text-align: center;
    height: 12px;
    font-size: 12px;
    font-weight: 400;
    color: #f00724;
    line-height: 12px;
  }
  .main_user_infor {
    margin-top: 4px;
    overflow: hidden;
    .main_user_box {
      padding-bottom: 6px;
      .main_user_infor_box {
        box-sizing: border-box;
        padding: 14px 26px 16px 18px;
        margin: 0 12px;
        height: 102px;
        background: #ffffff;
        box-shadow: 0px 4px 8px 0px #e6e6e6;
        border-radius: 8px;
        margin-top: 8px;
        .main_user_my_infor {
          width: 50%;
          display: inline-block;
          text-align: left;
          height: 14px;
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          line-height: 14px;
        }
        .main_user_my_code {
          width: 50%;
          display: inline-block;
          text-align: right;
          height: 14px;
          font-size: 14px;
          color: #f00724;
          line-height: 14px;
        }
        .main_sculpture {
          margin-top: 16px;
          .avatar {
            display: inline-block;
            margin-right: 12px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            vertical-align: top;
          }
          .infor {
            display: inline-block;
            vertical-align: top;
            .size_color {
              height: 16px;
              font-size: 14px;
              font-weight: 400;
              color: #333333;
              line-height: 16px;
              margin-left: 8px;
              width: 230px;
            }
          }
        }
      }
    }
  }
  // .my_hire_concent_box {
  //   // padding-bottom: 60px;
  //   // padding-top: 48px;
  // }
  .van-list__finished-text {
    height: 44px;
    line-height: 44px;
    font-size: 12px;
  }
  .my_hire_now {
    width: 351px;
    margin: 18px 12px 0 12px;
    text-align: center;
    height: 40px;
    background: #f00724;
    border-radius: 8px;
    line-height: 40px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
  }
  .my_hire_now_disable {
    width: 351px;
    margin: 18px 12px 0 12px;
    text-align: center;
    height: 40px;
    background: #dcdcdc;
    border-radius: 8px;
    line-height: 40px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
  }
  .van-tabs__wrap {
    height: 48px !important;
  }
  .betweenBottom {
    margin-bottom: 12px;
  }
  // .betweenBottoms {
  //   margin-bottom: 12px;
  // }
  .betweentop {
    margin-top: 8px;
  }
  .nickName {
    margin-left: 8px;
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .my_hier_size {
    height: 15px;
    line-height: 15px;
  }
  .noShares {
    height: 100;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #92909a;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .noShareText {
    padding-top: 24px;
  }
}
</style>